import React from 'react';

import { StyledTaskChip } from 'containers/Tasks/components/TasksTable/styles';
import { RiskActionStatus } from 'utils/api/modules/risks';
import { ScheduleStatus, TaskStatus } from 'utils/api/modules/tasks/tasks.constants';

import { RISK_ACTION_STATUS_OPTIONS } from './statuses';

const CHIP_STATUS: Record<RiskActionStatus, TaskStatus | ScheduleStatus> = {
  [RiskActionStatus.ToDo]: TaskStatus.ToDo,
  [RiskActionStatus.Done]: TaskStatus.Completed,
  [RiskActionStatus.Cancelled]: ScheduleStatus.WontDo,
};

const LABELS = new Map(RISK_ACTION_STATUS_OPTIONS.map(({ value, label }) => [value, label]));

const RiskActionStatusChip: React.FunctionComponent<{ status: RiskActionStatus }> = ({ status }) => (
  <StyledTaskChip
    status={CHIP_STATUS[status]}
    label={LABELS.get(status)}
    data-testid={`risk-action-status-${status}`}
  />
);

export default RiskActionStatusChip;
